import VideoShelf from '@/components/VideoShelf.vue';
import TextWidget from '@/components/TextWidget.vue';
import { initVue } from '@/vue';

initVue({
	components: {
		'text-widget': TextWidget,
		'video-shelf': VideoShelf,
	}
});
